import { type UseQueryResult, useQuery } from 'react-query';
import { BrokerSsoConfigurationService } from '../../services/wealthlane-identity-services/services/BrokerSsoConfigurationService';
import { Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationDto } from '../../services/wealthlane-identity-services/models/Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationDto';

const useGetBrokerSsoConfigurationList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationDto[] | undefined,
  unknown
> => {
  const brokerSsoConfigurationList = useQuery(
    ['getBrokerSsoConfigurationList', companyId],
    async () => {
      return await handleRequest(
        BrokerSsoConfigurationService.getApiIdentityApiAppBrokerSsoConfiguration(companyId)
      );
    }
  );
  return brokerSsoConfigurationList;
};

export default useGetBrokerSsoConfigurationList;
